import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, skip } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from './shared/services/login.service';
import { BannerService } from './shared/services/banner.service';

@Component({
  selector: 'ins-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  private userSub: Subscription;

  constructor(
    private loginService: LoginService,
    private toastr: ToastrService,
    private bannerService: BannerService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.loginService.isAuthenticated();
    this.loadBanners();

    this.userSub = this.loginService.currentUser$.pipe(skip(1)).subscribe((user) => {
      const wasLoggedIn = this.isLoggedIn;
      this.isLoggedIn = !!user;

      if (wasLoggedIn !== !!user) {
        this.loadBanners();
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  private loadBanners(): void {
    this.toastr.clear();
    this.bannerService.getActiveBanners().subscribe((banners) => {
      banners.forEach((banner) => {
        if (banner.value) {
          this.toastr.warning(banner.value, banner.name, {
            closeButton: true,
            newestOnTop: false,
            progressBar: false,
            positionClass: 'toast-bottom-full-width',
            timeOut: 0,
            extendedTimeOut: 0,
            enableHtml: true,
            tapToDismiss: false,
            disableTimeOut: true,
            messageClass: 'banner-custom-message',
            titleClass: 'banner-custom-title',
          });
        }
      });
    });
  }
}
